import { c as _c } from "react/compiler-runtime";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";
import { useTaskService } from "./useTaskServices";
import type { ExternalTaskSource, ExternalTasksResponse } from "../types";
interface ExternalTasksParams {
  source: ExternalTaskSource;
  limit?: number;
  filter?: string;
  dueDate?: Date;
}
export function useExternalTasks(params) {
  const $ = _c(14);
  const apiFetcher = useApiFetcher();
  const {
    source,
    limit: t0,
    filter,
    dueDate
  } = params;
  const limit = t0 === undefined ? 20 : t0;
  const {
    isConnected,
    isLoading: isCheckingConnection
  } = useTaskService(source);
  let t1;
  if ($[0] !== dueDate || $[1] !== filter || $[2] !== source) {
    t1 = [...QUERY_KEYS.externalTasks(source, filter, dueDate?.toISOString())];
    $[0] = dueDate;
    $[1] = filter;
    $[2] = source;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = isConnected && !isCheckingConnection;
  let t3;
  if ($[4] !== apiFetcher || $[5] !== dueDate || $[6] !== filter || $[7] !== limit || $[8] !== source) {
    t3 = async t4 => {
      const {
        pageParam
      } = t4;
      const queryParams = new URLSearchParams({
        limit: limit.toString()
      });
      if (pageParam && typeof pageParam === "string") {
        queryParams.set("cursor", pageParam);
      }
      if (dueDate) {
        queryParams.set("dueDate", dueDate.toISOString());
      }
      if (filter) {
        queryParams.set("filter", filter);
      }
      return apiFetcher(`/api/v1/tasks/external/${source}/tasks?${queryParams.toString()}`);
    };
    $[4] = apiFetcher;
    $[5] = dueDate;
    $[6] = filter;
    $[7] = limit;
    $[8] = source;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = {
      queryKey: t1,
      initialPageParam: null as string | null,
      staleTime: 0,
      gcTime: 0,
      enabled: t2,
      queryFn: t3,
      getNextPageParam: _temp
    };
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return useInfiniteQuery(t4);
}
function _temp(lastPage) {
  return lastPage?.data?.nextCursor || null;
}